import axios from "axios";
import base64 from 'react-native-base64';

import Config from "../config/Config";

const config = new Config();

export default axios.create({
  baseURL: config.WC_BASE_URL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": "true",
    "Access-Control-Allow-Methods": "GET, POST",
    "Authorization": 'Basic ' + base64.encode(config.CONSUMER_KEY + ":" + config.CONSUMER_SECRET) 
  }
});
